import { AppBar, Box, Container, Toolbar, Typography } from "@mui/material";
import Icon from "../../../icon";
import { useAppTheme } from "../../../theme";

const Menu = () => {
  const theme = useAppTheme();

  return (
    <Container>
      <AppBar
        position={"static"}
        color={"transparent"}
        sx={{ boxShadow: "none" }}
      >
        <Toolbar
          sx={{
            flex: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
          disableGutters
        >
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Icon
              icon={"icon"}
              width={32}
              height={32}
              color={theme.palette.primary.main}
            />
            <Typography variant={"h6"} color={theme.palette.primary.main}>
              Echonote
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
    </Container>
  );
};

export default Menu;
